import { createApp } from 'vue';
import VariantSelector from '../vue/VariantSelector';
import debounce from 'lodash.debounce';

class Ecommerce {
	cartState;
	isCartOpen = false;
	blurLayer;
	isMobile;

	constructor() {
		this.blurLayer = document.querySelector('[data-blur-layer]');
		this.isMobile = window.matchMedia('(max-width:991px)');

		wp.hooks.addAction('on.cartUpdate', 'shopwp', (cartState) => {
			this.cartState = cartState;
			this.updateCartButton();
		});

		wp.hooks.addAction(
			'on.cartToggle',
			'shopwp',
			debounce((data) => {
				this.isCartOpen = data.isCartOpen;

				if (data.isCartOpen) {
					this.blurLayer.classList.add('blur-layer--blurred');
					document.dispatchEvent(new CustomEvent('disable-scroll', {
						detail: {
							element: document.querySelector('.wps-cart-contents')
						}
					}));
				} else {
					this.blurLayer.classList.remove('blur-layer--blurred');
					document.dispatchEvent(new CustomEvent('enable-scroll'));
				}
			}, 50)
		);

		document.addEventListener('click', (e) => {
			if (e.target && e.target.closest('[data-open-cart]')) {
				wp.hooks.doAction('do.cartToggle', 'close'); // Weird bug
				setTimeout(() => { // Weird bug
					wp.hooks.doAction('do.cartToggle', 'open');
				}, 0);
			}
		});

		document.addEventListener('bless', (e) => {
			const container = e.detail.element;
			this.init(container);
		});
	}

	init(container) {
		container.querySelectorAll('.variant-selector-wrapper').forEach((element) => {
			const app = createApp({
				components: {
					'variant-selector': VariantSelector,
				},
			});
			app.mount(element);
		});

	}

	updateCartButton() {
		if (!this.cartState) {
			return;
		}
		document.querySelectorAll('[data-cart-quantity]').forEach((button) => {
			button.innerHTML = `[${this.cartState.cartData.totalQuantity}]`;
		});
	}

}

export const ecommerce = new Ecommerce();
